import React, { useEffect, useState } from "react"
import { Link } from 'gatsby'
import { useLocation } from '@reach/router';
import headerImg from "../images/Logo/LogoFinalWhite.png";
import { useIsMobile } from "../hooks/useIsMobile";

const Header = () => {
  // const path = window.location.pathname returns the current url minus the domain name

  const isMobile = useIsMobile();
  const [hasMounted, setHasMounted] = useState(false);

  useEffect(() => {
    setHasMounted(true);
  }, []);

  const path = useLocation();

  const handleScroll = () => {
    const winScroll = document.documentElement.scrollTop

    if (winScroll === 0 && path.pathname === '/') {
      document.getElementById('navbarEz').classList.add('navigation-wrap-transparent');
      document.getElementById('navbarEz').classList.add('start-style');
      document.getElementById('navbarEz').classList.remove('scroll-on');
    }
    else if (path.pathname !== '/' && winScroll === 0) {
      document.getElementById('navbarEz').classList.add('start-style');
      document.getElementById('navbarEz').classList.remove('navigation-wrap-transparent');
      document.getElementById('navbarEz').classList.remove('scroll-on');
    }
    else {
      document.getElementById('navbarEz').classList.remove('navigation-wrap-transparent');
      document.getElementById('navbarEz').classList.remove('start-style');
      document.getElementById('navbarEz').classList.add('scroll-on');
    }
  }

  useEffect(() => {
    handleScroll()
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll)
  }, [path.pathname])

  return (
    <div>
      <div className="navigation-wrap start-header start-style navigation-wrap-transparent" id="navbarEz">
        <div className="container px-0">
          <div className="row">
            <div className="col-12 grid">
              <nav className="navbar navbar-expand-md navbar-dark">

                <Link className="navbar-logo ml-4" to="/">
                  <img src={headerImg} width={157} layout="constrained" placeholder="blurred" alt='logo' />
                </Link>

                <button className="navbar-toggler ml-auto mr-4" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                  <span className="navbar-toggler-icon"></span>
                </button>

                <div className="collapse navbar-collapse" id="navbarSupportedContent">
                  <ul className="navbar-nav m-auto py-4 py-md-0">
                    <li className="nav-item pl-4 pl-md-0 ml-0 ml-md-4">
                      <Link className="nav-link" to="/" role="button">Home</Link>
                    </li>
                    <li className="nav-item pl-4 pl-md-0 ml-0 ml-md-4">
                      <Link className="nav-link" to="/#whoAreWe">About Us</Link>
                      {/* to="/#whoAreWe"  */}
                      {/* onClick={() => {
                        document.getElementById("navbarSupportedContent").classList.remove("show");
                      }} */}

                    </li>
                    <li className="nav-item pl-4 pl-md-0 ml-0 ml-md-4 dropdown">
                      {!hasMounted ? null : isMobile ? (
                        <Link className="nav-link" to="/services/">Services</Link>
                      ) : (
                        <>
                          {/* <Link className="nav-link dropdown-toggle">Services</Link> */}
                          <button type="button" className="nav-link dropdown-toggle" aria-haspopup="true" aria-expanded="false" style={{ outline: "none", background: "none", border: "none" }}>
                            Services
                          </button>

                          <div className="dropdown-menu">
                            <div className="row m-auto">
                              <div className="grid">
                                <Link to="/services/web-development/" className="dropdown-item">
                                  <div className="row p-3">
                                    <i className="fas fa-code center pr-3"></i>
                                    <p className="mb-0 para-color">Web Design & Development</p>
                                  </div>
                                </Link>
                                <Link to="/services/mobile-app-development/" className="dropdown-item">
                                  <div className="row row p-3">
                                    <i className="fas fa-mobile center pr-4"></i>
                                    <p className="mb-0 para-color">Mobile App Development</p>
                                  </div>
                                </Link>
                                <Link to="/services/software-development/" className="dropdown-item">
                                  <div className="row row p-3">
                                    <i className="far fa-browser center pr-3"></i>
                                    <p className="mb-0 para-color">Software Development</p>
                                  </div>
                                </Link>
                                <Link to="/services/ui-design/" className="dropdown-item">
                                  <div className="row row p-3">
                                    <i className="fab fa-uikit center pr-3"></i>
                                    <p className="mb-0 para-color">UI/UX Design</p>
                                  </div>
                                </Link>
                              </div>
                              <div className="grid">
                                <Link to="/services/quality-assurance/" className="dropdown-item">
                                  <div className="row p-3">
                                    <i className="fas fa-fingerprint center pr-3"></i>
                                    <p className="mb-0 para-color">Quality Assurance</p>
                                  </div>
                                </Link>
                                <Link to="/services/graphics-design/" className="dropdown-item">
                                  <div className="row row p-3">
                                    <i className="fab fa-artstation center pr-3"></i>
                                    <p className="mb-0 para-color">Graphics Design</p>
                                  </div>
                                </Link>
                                <Link to="/services/search-engine-optimization/" className="dropdown-item">
                                  <div className="row row p-3">
                                    <i className="fab fa-searchengin center pr-3"></i>
                                    <p className="mb-0 para-color">Search Engine Optimization</p>
                                  </div>
                                </Link>
                                <Link to="/services/cloud-computing/" className="dropdown-item">
                                  <div className="row row p-3">
                                    <i className="fad fa-clouds center pr-3"></i>
                                    <p className="mb-0 para-color">Cloud Computing</p>
                                  </div>
                                </Link>
                              </div>

                            </div>
                          </div>
                        </>
                      )}
                    </li>
                    <li className="nav-item pl-4 pl-md-0 ml-0 ml-md-4">
                      <Link className="nav-link" to="/#features">Features</Link>
                    </li>
                    <li className="nav-item pl-4 pl-md-0 ml-0 ml-md-4">
                      <Link className="nav-link" to="/#testimonials">Testimonials</Link>
                    </li>
                    <li className="nav-item pl-4 pl-md-0 ml-0 ml-md-4">
                      <Link className="nav-link" to="/#contact">Contact Us</Link>
                    </li>
                  </ul>
                </div>

                <div className="socials row mr-0">
                  {/* <Link to="https://www.facebook.com/Code-Frenetics-101390369213086/" target='_blank'><i className="fab fa-facebook ml-4"></i></Link>
                  <Link to="https://www.instagram.com/codefrenetics/" target='_blank'><i className="fab fa-instagram ml-4"></i></Link>
                  <Link to="https://twitter.com/FreneticsApps" target='_blank'><i className="fab fa-twitter ml-4"></i></Link>
                  <Link to="https://www.linkedin.com/company/code-frenetics" target='_blank'><i className="fab fa-linkedin ml-4"></i></Link> */}
                  <a href="https://www.facebook.com/Code-Frenetics-101390369213086/" target="_blank" rel="noopener noreferrer" aria-label="Visit our Facebook page">
                    <i className="fab fa-facebook ml-4"></i>
                  </a>
                  <a href="https://www.instagram.com/codefrenetics/" target="_blank" rel="noopener noreferrer" aria-label="Visit our Instagram profile" >
                    <i className="fab fa-instagram ml-4"></i>
                  </a>
                  <a href="https://twitter.com/FreneticsApps" target="_blank" rel="noopener noreferrer" aria-label="Visit our Twitter profile">
                    <i className="fab fa-twitter ml-4"></i>
                  </a>
                  <a href="https://www.linkedin.com/company/code-frenetics" target="_blank" rel="noopener noreferrer" aria-label="Visit our LinkedIn page">
                    <i className="fab fa-linkedin ml-4"></i>
                  </a>
                </div>
              </nav>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Header
